module.exports = __webpack_public_path__ + "static/media/85x11no2.188e1a56.jpg";